import { render, staticRenderFns } from "./MsgElementCommonQuestions.vue?vue&type=template&id=37de29a6&scoped=true"
import script from "./MsgElementCommonQuestions.vue?vue&type=script&lang=js"
export * from "./MsgElementCommonQuestions.vue?vue&type=script&lang=js"
import style0 from "./MsgElementCommonQuestions.vue?vue&type=style&index=0&id=37de29a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de29a6",
  null
  
)

export default component.exports